import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { applicationStatusApis } from '../../constants/application-status-api';
import { HttpClientService } from '../httpClient/httpClient.service';
import { PaginationType } from '../../interfaces/pagination/pagination-type';

@Injectable({
  providedIn: 'root'
})
export class ApplicationStatusService {
  
  constructor(private httpClientService: HttpClientService) {}

  getPrimaryStatusesList(): Observable<any> {
      // return this.httpClientService.get(`${applicationStatusApis.getPrimaryStatusesList}?skip=${pagination.skip}&limit=${pagination.limit}`);
      return this.httpClientService.get(`${applicationStatusApis.getPrimaryStatusesList}`);
  }
  getPrimaryStatusesLists(pagination: PaginationType, filters?: any): Observable<any> {
    let query = '?'
    if (filters) {
      query += filters;
  }
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    // return this.httpClientService.get(`${applicationStatusApis.getPrimaryStatusesList}?skip=${pagination.skip}&limit=${pagination.limit}`);
    return this.httpClientService.get(`${applicationStatusApis.getPrimaryStatusesList}${query}`);
  }

  getPrimaryStatusesListsUpdate(pagination: PaginationType, filters?: any): Observable<any> {
    let query = '?'
    if (filters) {
      query += filters;
  }
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    // return this.httpClientService.get(`${applicationStatusApis.getPrimaryStatusesList}?skip=${pagination.skip}&limit=${pagination.limit}`);
    return this.httpClientService.get(`${applicationStatusApis.getPrimaryStatusesListUpdate}${query}`);
  }

  getPrimaryStatusesbyId(id: string): Observable<any> {
      return this.httpClientService.get(applicationStatusApis.getPrimaryStatusesbyId.replace(':primaryStatusId', id));
  }

  createPrimaryStatuses(payload: unknown): Observable<any> {
      return this.httpClientService.post(applicationStatusApis.createPrimaryStatuses, payload);
  }

  updatePrimaryStatusesById(id: string, payload: unknown): Observable<any> {
      return this.httpClientService.put(applicationStatusApis.updatePrimaryStatusesById.replace(':primaryStatusId', id), payload);
  }

  deletePrimaryStatusesId(id: string): Observable<any> {
      return this.httpClientService.delete(applicationStatusApis.deletePrimaryStatusesId.replace(':primaryStatusId', id));
  }
//?secondary
  getSecondaryStatusesList(pagination: PaginationType, filters?: any): Observable<any> {
    let query = '?'
    if (filters) {
      query += filters;
  }
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${applicationStatusApis.getSecondaryStatusesList}${query}`);
  }

  getSecondaryStatusesListUpdate(pagination: PaginationType, filters?: any): Observable<any> {
    let query = '?'
    if (filters) {
      query += filters;
  }
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${applicationStatusApis.getSecondaryStatusesListupdate}${query}`);
  }

  getSecondaryStatuses(): Observable<any> {
    return this.httpClientService.get(`${applicationStatusApis.getSecondaryStatusesList}?skip=0&limit=500`);
  }

  getSecondaryStatusesbyId(id: string, pagination?: PaginationType): Observable<any> {
      let query = '';
      query += `&skip=${pagination.skip}&limit=${pagination.limit}`;
      return this.httpClientService.get(`${applicationStatusApis.getSecondaryStatusesbyId}${id}${query}`);
  }

  createSecondaryStatuses(payload: unknown): Observable<any> {
      return this.httpClientService.post(applicationStatusApis.createSecondaryStatuses, payload);
  }

  updateSecondaryStatusesById(id: string, payload: unknown): Observable<any> {
      return this.httpClientService.put(applicationStatusApis.updateSecondaryStatusesById.replace(':secondaryStatusId', id), payload);
  }

  deleteSecondaryStatusesId(id: string): Observable<any> {
      return this.httpClientService.delete(applicationStatusApis.deleteSecondaryStatusesId.replace(':secondaryStatusId', id));
  }

  //?autoChange
  getAutoUpdateStatusesList(): Observable<any> {
    return this.httpClientService.get(`${applicationStatusApis.getAutoUpdateStatusList}`);
  }

  getAutoUpdateStatusesbyId(id: string): Observable<any> {
      return this.httpClientService.get(applicationStatusApis.getAutoUpdateStatusesbyId.replace(':autoUpdateStatusId', id));
  }

  getAutoUpdateStatusesUploadDoc(id: string, pagination: PaginationType): Observable<any> {
    return this.httpClientService.get(`${applicationStatusApis.getAutoUpdateStatusesUploadDoc}${id}&skip=${pagination.skip}&limit=${pagination.limit}`, );
  }

  autoChangesUpload(payload: unknown): Observable<any> {
    return this.httpClientService.upload(applicationStatusApis.autoChangesUpload, payload);
  }

  createAutoUpdateStatuses(payload: unknown): Observable<any> {
      return this.httpClientService.post(applicationStatusApis.createAutoUpdateStatuses, payload);
  }

  updateAutoUpdateStatusesById(id: string, payload: unknown): Observable<any> {
      return this.httpClientService.put(applicationStatusApis.updateAutoUpdateStatusesById.replace(':autoUpdateStatusId', id), payload);
  }

  deleteAutoUpdateStatusesId(id: string): Observable<any> {
      return this.httpClientService.delete(applicationStatusApis.deleteAutoUpdateStatusesId.replace(':autoUpdateStatusId', id));
  }


  //?internalStatus
  getInternalStatusesList(): Observable<any> {
    return this.httpClientService.get(applicationStatusApis.getInternalStatusStatusList);
  }

  getInternalStatusesbyId(id: string): Observable<any> {
    return this.httpClientService.get(applicationStatusApis.getInternalStatusStatusesbyId.replace(':internalStatusId', id));
  }

  createInternalStatuses(payload: unknown): Observable<any> {
    return this.httpClientService.post(applicationStatusApis.createInternalStatusStatuses, payload);
  }

  updateInternalStatusesById(id: string, payload: unknown): Observable<any> {
    return this.httpClientService.put(applicationStatusApis.updateInternalStatusStatusesById.replace(':internalStatusId', id), payload);
  }

  deleteInternalStatusesId(id: string): Observable<any> {
    return this.httpClientService.delete(applicationStatusApis.deleteInternalStatusStatusesId.replace(':internalStatusId', id));
  }

  //?communicationStatus
  getCommunicationStatusList(pagination: PaginationType): Observable<any> {
    return this.httpClientService.get(
      `${applicationStatusApis.getAgentCommunicationStatusStatusList}?skip=${pagination.skip}&limit=${pagination.limit}`
    );
  }

  getCommunicationStatusbyId(id: string): Observable<any> {
    return this.httpClientService.get(applicationStatusApis.getAgentCommunicationStatusStatusesbyId.replace(':agentCommunicationStatusId', id));
  }

  createCommunicationStatus(payload: unknown): Observable<any> {
    return this.httpClientService.post(applicationStatusApis.createAgentCommunicationStatusStatuses, payload);
  }

  updateCommunicationStatusById(id: string, payload: unknown): Observable<any> {
    return this.httpClientService.put(applicationStatusApis.updateAgentCommunicationStatusStatusesById.replace(':agentCommunicationStatusId', id), payload);
  }

  deleteCommunicationStatusId(id: string): Observable<any> {
    return this.httpClientService.delete(applicationStatusApis.deleteAgentCommunicationStatusStatusesId.replace(':agentCommunicationStatusId', id));
  }
}
